module.exports = __webpack_public_path__ + "static/media/AU Research Roster - 2h - deleted 2018 study ID 6.03397a4c.csv";